module.exports = __webpack_public_path__ + "img/s-stark-white.cb45e77a.png";